<template>
  <div class="account">
    <div class="pub_content">
      <div class="box">
        <el-form :model="params" ref="ruleForm">
          <el-form-item
            :label="info && info.role==='UserRoleSchool'?'学校校徽':'头像：'"
            :label-width="label_width"
            prop="head"
            :rules="[{ required: true, message: '请上传头像', trigger: 'blur' }]"
          >
            <div class="myupload">
              <div class="myupload_l">
                <AppCropper :params="params" :config="imgconfig"/>
              </div>
              <div class="myupload_r">
                <p>1.请上传个人真实头像,文件格式为jpg,png,bmp,建议图片尺寸100*100</p>
                <p>2.用于个人中心展示个人风采</p>
              </div>
            </div>
            <input type="hidden" v-model="params.head" />
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            label="用户名："
            :rules="[{ required: true, message: '请输用户昵称', trigger: 'blur' }]"
          >
            <el-input
              style="width:371px"
              prop="user_name"
              maxlength="25"
              show-word-limit
              v-model="params.user_name"
              placeholder="用户名可用于登录"
            ></el-input>
          </el-form-item>
         

          <el-form-item :label-width="label_width">
            <!-- 普通用户 -->
            <el-button class="notarize" type="primary" @click="submit(1)">保 存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import uploadImg from "@/components/file_upload/uploadImg.vue";
import provincialSelection from "@/components/provincial_selection/provincial_selection.vue";
import AppCropper from "@/components/file_upload/Cropper2.vue";
export default {
  components: {
    uploadImg,
    provincialSelection,
    AppCropper
  },
  data() {
    return {
      config: {
        province: {
          disabled: true
        },
        city: {
          disabled: true
        },
        county: {
          disabled: true
        }
      },
      imgconfig:{
        autoCropWidth:100,//裁图大小
        autoCropHeight:100,
        width:100,//表单展示框大小
        height:100,
        fixedNumber:[1,1],//裁剪框比例
        params: {
          catalog: "CatalogWhaleImage",
          is_public_read: true
        },
        imgSize:0.5,//上传图像大小
        imgPath: "headPath", //图片展示字段
        fileId: "head" //文件id字段，用户接口传参
      },
      list: null,
      label_width: "120px",
      DesignField: [],
      DesignerProfession: [],
      params: {
        province: "", //省
        city: "" //市
      },
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    }
  },
  created() {
    if (this.info) {
      this.initData();
    } else {
      this.needInfo("info", "initData");
    }
    if (this.designer) {
      this.initData();
    } else {
      this.needInfo("designer", "initData");
    }
  },
  methods: {
    // 重新获取用户信息
    initInfo() {
      this.common.getUserInfo(true).then(res => {
        let params = { user: res && res.id, role: res && res.role };
        if (res) {
          return this.common.getFrontDesigners(params, true);
        }
      });
    },
    // 初始化数据
    initData() {
      if (this.info) {
        this.params = Object.assign({}, this.params, {
          user_name: this.info.user_name,
          head: this.info.head,
          headPath: this.info.headPath
        });
      }
    },
    // 获取设计师信息
    getFrontDesigners() {
      this.params = Object.assign({}, this.params, {
        user_name: this.info.user_name
      });
      return new Promise(resolve => {
        this.api
          .getFrontDesigners({
            user_id: this.info.id
          })
          .then(res => {
            if (res.error.err_code !== 0) return;
            let list = res.obj.list[0] || null;
            let design_fields = "";
            if (list) {
              design_fields = list.design_fields_id.trim();
              design_fields = design_fields.length
                ? design_fields.split(",")
                : [];
            }

            this.params = Object.assign({}, this.params, list, {
              design_fields
            });
            resolve();
          });
      });
    },
    /* 监测个人信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },

    /*提交用户信息*/
    submit: function(num) {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          /* 更新用户信息 */
          num === 1 && this.updateUser(); //认证前
        } else {
          return false;
        }
      });
    },
   
    //认证前更新用户信息
    updateUser: function() {
      let params = Object.assign({},this.params,{
        headPath:''
      })
      this.api.updateUser(this.params, true).then(res => {
        if (res.error.err_code === 0) {
          this.$message.info("保存成功!");
          this.initInfo();
        }
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
@import "../index.scss";
.account {
  .box {
    background: #fff;
    padding: 30px 30px 56px;
  }

  .myupload {
    display: flex;

    .myupload_r {
      margin-left: 10px;
      font-size: 12px;
      color: #999;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        white-space: nowrap;
        line-height: 18px;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 70px;
      height: 70px;
      line-height: 70px;
      text-align: center;
    }
    .avatar {
      width: 78px;
      height: 78px;
      display: block;
    }
  }
}
</style>